export default "__VITE_ASSET__11b57aad__"